/**
 * Global Healthcheck configuration
 */

export const enabled = true;
export const delayedStart = false;
export const validRoles = ["ROLE_SITE_ADMIN", "ROLE_ADMIN"];
export const LS_KEY = "rvc.tools";

// interval values in minutes
export const interval = {
  min: 1,
  max: 5,
  default: 5,
};
